import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from './breadcrumbs/Breadcrumbs';
import UsersList from './UsersList';
import './subheader.scss';
import { locationShape } from '../../routerPropTypes';
import ShakeFeature from '../shakeApp/ShakeFeature';

const Subheader = ({ currentItem, location, shakeAccess, user }) => {
  const isInProject = currentItem?.itemtype === 'project';
  const displayShake =
    isInProject && shakeAccess && (user.role.S !== 'pro' || user.role.S !== 'admin');
  const subHeaderClassName = isInProject ? 'subheaderProject' : 'subheader';
  return (
    <div className={subHeaderClassName}>
      <div className="wrapper">
        <Breadcrumbs currentItem={currentItem} location={location} />
        {displayShake && <ShakeFeature projectId={currentItem.projectId} />}
        <UsersList />
      </div>
    </div>
  );
};
export default Subheader;

Subheader.propTypes = {
  // router prop types
  currentItem: PropTypes.object,
  location: PropTypes.shape(locationShape).isRequired,
};

Subheader.defaultProps = {
  currentItem: undefined,
};
